<template>
  <span :class="classBinding" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface IconProps {
  type: string
  size?: string
  aspect?: string
}

const props = withDefaults(defineProps<IconProps>(), {
  size: 'small',
  aspect: ''
})

const $style = useCssModule()

const classBinding = computed(() => {
  const iconType = $style[`icon-${props.type}`]
  const iconSize = $style[`icon-${props.size}`]
  const iconAspect = $style[`icon-${props.aspect}`]
  let classString = `${iconType} ${iconSize}`
  classString = props.aspect ? `${classString} ${iconAspect}` : classString

  return classString
})
</script>
<style lang="scss" module>
@mixin icon-desktop {
  mask-size: cover;
  background: rgb(var(--v-theme-iconDesktop));
  &:hover {
    background: rgb(var(--v-theme-hover));
  }
}
.icon {
  /*
  **  Sizes
  */
  &-four-by-three{
    aspect-ratio: 4 / 3;
    height: unset;
  }

  &-xs {
    width: 1em;
    height: 1em;
  }

  &-sm {
    width: 1.33em;
    height: 1.33em;
  }

  &-lg {
    width: 1.67em;
    height: 1.67em;
  }

  &-xl {
    width: 2.3em;
    height: 2.3em;
  }

  @for $index from 2 through 10 {
    &-#{$index}x {
      width: #{$index}em;
      height: #{$index}em;
    }
  }

  /*
  **  Icons
  **  TODO: should be categories
  */

  &-chevron-down {
    background: url('~/assets/images/icons/chevron-down.svg');
    background-repeat: no-repeat;
  }

  &-chevron-left {
    background: url('~/assets/images/icons/chevron-left.svg');
    background-repeat: no-repeat;
  }

  &-chevron-right {
    background: url('~/assets/images/icons/chevron-right.svg');
    background-repeat: no-repeat;
  }

  &-map-marker {
    background: url('~/assets/images/icons/map-marker.svg');
    background-repeat: no-repeat;
  }

  &-minus {
    background: url('~/assets/images/icons/minus.svg');
    background-repeat: no-repeat;
  }

  &-plus {
    background: url('~/assets/images/icons/plus.svg');
    background-repeat: no-repeat;
  }

  &-triangle-alert {
    background: url('~/assets/images/icons/triangle-alert.svg');
    background-repeat: no-repeat;
  }

  &-envelope {
    background: url('~/assets/images/icons/envelope.svg');
    background-repeat: no-repeat;
  }

  &-user-female {
    background: url('~/assets/images/icons/user-female.svg');
    background-repeat: no-repeat;
  }

  &-credit-card {
    background: url('~/assets/images/icons/credit-card.svg');
    background-repeat: no-repeat;
  }

  &-call {
    background: url('~/assets/images/icons/call.svg');
    background-repeat: no-repeat;
  }

  &-package {
    background: url('~/assets/images/icons/package.svg');
    background-repeat: no-repeat;
  }

  &-color-check {
    background: url('~/assets/images/icons/color-check.svg');
    background-repeat: no-repeat;
  }

  &-search {
    background: url('~/assets/images/icons/search.svg');
    background-repeat: no-repeat;
  }

  &-menu {
    background: url('~/assets/images/icons/menu.svg');
    background-repeat: no-repeat;
  }

  &-menu-close-narrow {
    background: url('~/assets/images/icons/menu-close-narrow.svg');
    background-repeat: no-repeat;
  }

  &-menu-close {
    background: url('~/assets/images/icons/menu-close.svg');
    background-repeat: no-repeat;
  }

  &-menu-close-wide {
    background: url('~/assets/images/icons/menu-close-wide.svg');
    background-repeat: no-repeat;
  }

  &-su-logo-desktop {
    background: url('~/assets/images/icons/su-logo-desktop.svg');
    background-repeat: no-repeat;
  }

  &-su-logo-mobile {
    background: url('~/assets/images/icons/su-logo-mobile.svg');
    background-repeat: no-repeat;
  }

  &-ios-share {
    background: url('~/assets/images/icons/ios-share.svg');
    background-repeat: no-repeat;
  }

  &-coordinating-products {
    background: url('~/assets/images/icons/coordinating_products.svg');
    background-repeat: no-repeat;
  }

  /*
  **  Flags
  */

  &-flag-at {
    background: url('~/assets/images/icons/countries/at.svg');
    background-repeat: no-repeat;
  }

  &-flag-au {
    background: url('~/assets/images/icons/countries/au.svg');
    background-repeat: no-repeat;
  }

  &-flag-ca {
    background: url('~/assets/images/icons/countries/ca.svg');
    background-repeat: no-repeat;
  }

  &-flag-de {
    background: url('~/assets/images/icons/countries/de.svg');
    background-repeat: no-repeat;
  }

  &-flag-fr {
    background: url('~/assets/images/icons/countries/fr.svg');
    background-repeat: no-repeat;
  }

  &-flag-gb {
    background: url('~/assets/images/icons/countries/gb.svg');
    background-repeat: no-repeat;
  }

  &-flag-nl {
    background: url('~/assets/images/icons/countries/nl.svg');
    background-repeat: no-repeat;
  }

  &-flag-be {
    background: url('~/assets/images/icons/countries/be.svg');
    background-repeat: no-repeat;
  }

  &-flag-ie {
    background: url('~/assets/images/icons/countries/ie.svg');
    background-repeat: no-repeat;
  }

  &-flag-nz {
    background: url('~/assets/images/icons/countries/nz.svg');
    background-repeat: no-repeat;
  }

  &-flag-us {
    background: url('~/assets/images/icons/countries/us.svg');
    background-repeat: no-repeat;
  }
}
</style>
